/**
 * Met la premiere lettre en minuscule, en tolerant une valeur absente.
 *
 * Sert a raccorder un libelle de regle de commission au milieu d'une phrase
 * (« Pour chaque place vendue, <libelle> »). Meme motif de tolerance que les
 * formateurs de montant : un `libelle.charAt(0)` sur `undefined` levait dans le
 * `computed` du dialogue et empechait tout affichage.
 */
export function enMinusculeInitiale(valeur: string | null | undefined): string {
  return valeur ? valeur.charAt(0).toLowerCase() + valeur.slice(1) : '';
}
